import React from 'react';
import styled from 'styled-components';

import { colors } from '../styles';

const Textarea = props => {

  return (
    <>
      <TextareaWrapper {...props} />
    </>
  );
};

const TextareaWrapper = styled.textarea`
  color: ${colors.midnightBlack};
  border: 1px solid ${colors.gray3};
  font-size: 16px;
  display: block;
  width: 100%;
  height: 140px;
  padding: 8px;
  text-indent: 8px;  

  ::placeholder {
    color: ${colors.gray2};
  }

  &:focus,
  &:active {
    outline: 0;
    border: 1px solid ${colors.crederaRed};
  }
`;

export { Textarea };
